module.exports = __webpack_public_path__ + "static/media/butacas.d27f3e37.png";